import { clienteApi } from '../../common/axios';

export const preferitiService = {
  list: () => clienteApi.get('/cliente/preferiti'),
  add: (categoriaId, notifica = true) => clienteApi.post('/cliente/preferiti', {
    categoria_catalogo_id: categoriaId,
    notifica_nuovi: notifica,
  }),
  remove: (categoriaId) => clienteApi.delete(`/cliente/preferiti/${categoriaId}`),
  toggleNotifica: (categoriaId) => clienteApi.patch(`/cliente/preferiti/${categoriaId}/notifica`),
};

export default preferitiService;
